import { defineComponent as _defineComponent } from 'vue'
import { ref, getCurrentInstance, onMounted } from "vue";
import FacilityFilter from "@/views/client/facility/filter/FacilityFilter.vue";
import FacilityCard from "@/views/client/facility/list/FacilityCard.vue";
import Loading from "@/components/atoms/loading/Loading.vue";
import { formatDate } from "../requests/list/shared/utils";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const instance = getCurrentInstance();
const proxy = instance && instance.proxy as any;
const title = "Seleccionar facilidad";
const isLoading = ref<boolean>(false);

const companies = computed(() => proxy.$store.state.user && proxy.$store.state.user.companies);
const selectedCompany = computed({
  get: () => proxy.$store.state.companyId,
  set: (id: string) => {
    if (!id) return;
    proxy.$store.commit("setCompanyId", id);
  }
});

onMounted(() => {
  isLoading.value = true;
  try {
    selectedCompany.value = selectedCompany.value || companies.value[0].id;
  } finally {
    isLoading.value = false;
  }
});


function selectCompany(id: string) {
  selectedCompany.value = id;
}

const getRange = (company: any) => {
  return `${formatDate(company.date_request_from)} - ${formatDate(company.date_request_to)}`;
};


return { __sfc: true,instance, proxy, title, isLoading, companies, selectedCompany, selectCompany, getRange, FacilityCard, Loading }
}

})